/*
  Handles API call to send Transmit Health record data
*/
import React, { Component } from 'react';
import { func, object } from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import AutoComplete from 'material-ui/AutoComplete';

import HealthApi from '../../../../apis/health.js';
import LoadingState from '../../../LoadingState';
import portalTheme from "../../../../themes/portalTheme";

import cx from 'classnames';
import s from './HealthRecordTransmitForm.css';


export default class HealthRecordTransmitForm extends Component {
  static propTypes = {
    closeAlertDialog: func,
    openErrorDialog: func,
    openSuccessDialog: func,
    handleViewTransmitForm: func,
    transmitData: object,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isDirectAddress: false,
      hasError: {
        status: false,
      },
      recipients: [],
      selectedRecipient: '',
    };

    this.successDialogTitle = 'Message Sent!';
    this.successDialogMessage = 'We will respond as soon as we can.';
  }

  componentDidMount() {
    HealthApi.getPossibleRecipients((json) => {
      if (json.successful) {
        this.setState({
          recipients: json.recipients,
        });
      }
    }).catch(error => {
      this.props.openErrorDialog({
        title: 'Failed to get possible recipients for transmit.',
        content: 'An unexpected error occurred', // TODO: What should the real message be?
        okCallback: this.handleDialogClose,
      });
    });
  }

  handleSelectChange = (recipient) => {
    this.setState({ selectedRecipient: recipient });
    this.handleIsDirect(recipient);
  };

  handleTransmit = () => {
    // If someone typed in the value, rather than using a saved Direct Address, capture it with a ref.
    // This one is a bit gnarly because of how Material-UI nests its 'ref' object.
    const typedInEmail = this.refs.email.refs.searchTextField.input.defaultValue;

    const data = {
      id: this.props.transmitData.id,
      format: this.props.transmitData.format,
      to: (this.state.selectedRecipient || typedInEmail),
      subject: this.refs.subject.value,
      message: this.refs.message.value,
    };

    HealthApi.transmitRecord(data, (json) => {
      if (json.successful) {
        this.setState({
          isLoading: false,
          hasError: {
            status: false,
          },
        });

        this.props.openSuccessDialog({
          title: this.successDialogTitle,
          content: this.successDialogMessage,
          okCallback: this.handleDialogClose,
        });
      } else {
        this.setState({
          isLoading: false,
          hasError: {
            status: true,
          },
        });

        this.props.openErrorDialog({
          title: 'There was an error!',
          content: json.error.message,
          okCallback: this.handleDialogClose,
        });
      }
    }).catch(error => {
      this.props.openErrorDialog({
        title: 'Failed to transmit record.',
        content: 'An unexpected error occurred', // TODO: What should the real message be?
        okCallback: this.handleDialogClose,
      });
    });
  };

  handleIsDirect = (chosenRequest) => {
    // If user triggers onChange of an empty field, do not make API call
    if (!chosenRequest) {
      return;
    }

    const data = { address: chosenRequest };

    HealthApi.checkIfDirect(data, (response) => {
      const isDirect = response.isDirectAddress;
      if (isDirect) {
        this.setState({
          selectedRecipient: chosenRequest,
          isDirectAddress: true,
        });
      }
      else {
        this.setState({
          selectedRecipient: chosenRequest,
          isDirectAddress: false,
        });
      }
    })
    .catch((error) => this.props.handleError(error));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    this.handleTransmit();
  };

  // If our state is in error, do not close the panel.
  handleDialogClose = () => {
    if (this.state.hasError.status) {
      this.props.closeAlertDialog();
    } else {
      this.props.closeAlertDialog();
      this.props.handleViewTransmitForm();
    }
  };

  render = () => {
    const lockIconStyle = (this.state.isDirectAddress ? s.lockIcon : s.unlockIcon);

    return (
      <section className={s.component}>
        <h3 className={s.header}>
          Send Information
        </h3>
        <p className={s.instructions}>
          You may send your Health Record to another doctor or practice by using either secure Direct Messaging or standard email.
          The method will be determined automatically based on the address you enter.
        </p>
        <div className={s.formWrapper}>
          <form
            className={s.form}
            id="transmitRecord"
            onSubmit={this.handleSubmit}
          >
            <div className={s.group}>
              <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
                <AutoComplete
                  title="Email Address"
                  hintText="Email Address"
                  hintStyle={{color:'#222222'}}
                  textFieldStyle={{color: '#222222'}}
                  dataSource={this.state.recipients}
                  onNewRequest={recipient => this.handleSelectChange(recipient)}
                  onUpdateInput={text => this.setState({selectedRecipient: text})}
                  onBlur={() => this.handleIsDirect(this.state.selectedRecipient)}
                  filter={AutoComplete.noFilter}
                  fullWidth={true}
                  openOnFocus={true}
                  className={lockIconStyle}
                  ref="email"
                  required
                />
              </MuiThemeProvider>
              <label htmlFor="subject" className={s.hidden}>Subject</label>
              <input
                id="subject"
                type="text"
                ref="subject"
                name="subject"
                required
                placeholder="Subject"
                className={cx(s.control, s.margins)}
              />
              <label htmlFor="message" className={s.hidden}>Message</label>
              <textarea
                id="message"
                className={cx(s.control, s.textarea)}
                placeholder="Your message here..."
                rows="5"
                ref="message"
                name="message"
                required
              />
            </div>
            <div className={cx(s.group, s.actions)}>
              <button
                id={`send__${this.props.transmitData.format}`}
                type="submit"
                className={s.btn}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <LoadingState context="transmitRecord" />
                ) : (
                  'Send'
                )}
              </button>
              <button
                id={`cancel__${this.props.transmitData.format}`}
                className={s.btnSecondary}
                onClick={this.props.handleViewTransmitForm}
                disabled={this.state.isLoading}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordTransmitForm/HealthRecordTransmitForm.js